import { useAuthContext } from "@asgardeo/auth-react";
import { useEffect, useState } from "react";
import AccessDenied from "../../pages/AccessDenied/AccessDenied";

const GroupGuard = ({ children }) => {
    const { state, getDecodedIDToken, signIn } = useAuthContext();
    const [authorized, setAuthorized] = useState(null);

    const groupAuthEnabled =
        import.meta.env.VITE_GROUP_AUTH_ENABLED === "true";
    const allowedGroups = import.meta.env.VITE_ALLOWED_GROUPS
        ? import.meta.env.VITE_ALLOWED_GROUPS.split(",").map((g) => g.trim())
        : [];

    useEffect(() => {
        // If group auth is disabled, allow everyone through
        if (!groupAuthEnabled) {
            setAuthorized(true);
            return;
        }

        // Wait for SDK to finish loading
        if (state.isLoading) {
            return;
        }

        // If not authenticated, trigger login
        if (!state.isAuthenticated) {
            signIn();
            return;
        }

        // Authenticated — check group membership
        getDecodedIDToken()
            .then((decodedToken) => {
                const userGroups = decodedToken?.groups || [];
                const hasAccess = userGroups.some((group) =>
                    allowedGroups.includes(group)
                );
                setAuthorized(hasAccess);
            })
            .catch(() => {
                setAuthorized(false);
            });
    }, [state.isAuthenticated, state.isLoading]);

    // Group auth disabled — render app normally
    if (!groupAuthEnabled) {
        return children;
    }

    // Still loading or checking
    if (state.isLoading || authorized === null) {
        return null;
    }

    // Not authorized
    if (!authorized) {
        return <AccessDenied />;
    }

    // Authorized
    return children;
};

export default GroupGuard;
